module.exports = __webpack_public_path__ + "img/17_15.22fe183d.png";